import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Avatar, Loading } from "@/components/shared/UI";
import { ArrowRight } from "lucide-react";

const EVENT_LABEL = { created: "created this task", completed: "completed this task", updated: "made changes" };

function when(iso) {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
}

const show = (v) => (v === null || v === undefined || v === "" || (Array.isArray(v) && !v.length) ? "empty" : Array.isArray(v) ? v.join(", ") : String(v));

function ChangeRow({ field, change }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs">
      <span className="font-semibold text-slate-600">{field.replace(/_/g, " ").replace(/ ids?$/, "")}</span>
      <span className="max-w-[40%] truncate rounded bg-red-50 px-1.5 py-0.5 text-red-600" title={show(change.from)}>{show(change.from)}</span>
      <ArrowRight className="h-3 w-3 text-slate-300" />
      <span className="max-w-[40%] truncate rounded bg-emerald-50 px-1.5 py-0.5 text-emerald-700" title={show(change.to)}>{show(change.to)}</span>
    </div>
  );
}

export function TaskHistoryTab({ taskId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    client.get(`/actions/${taskId}/history`).then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [taskId]);
  if (rows === null) return <Loading />;
  if (!rows.length) return <p className="py-6 text-center text-sm text-slate-400" data-testid="task-history-empty">No history recorded yet.</p>;
  return (
    <div className="space-y-2" data-testid="task-history-list">
      {rows.map((h) => (
        <div key={h.id} data-testid={`task-history-item-${h.id}`} className="rounded-lg border border-slate-100 p-3">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <Avatar name={h.actor_name} user className="h-6 w-6 shrink-0 text-[9px]" />
            <span className="text-xs font-semibold text-slate-700">{h.actor_name || "Someone"}</span>
            <span className="text-xs text-slate-500">{EVENT_LABEL[h.event] || h.event}</span>
            <span className="ml-auto whitespace-nowrap text-[11px] text-slate-400">{when(h.at)}</span>
          </div>
          {h.event !== "created" && Object.keys(h.changes || {}).length > 0 && (
            <div className="mt-2 space-y-1">
              {Object.entries(h.changes).map(([f, c]) => <ChangeRow key={f} field={f} change={c} />)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
